import type { ItemRenderer } from "./types";

export const renderPerforatedPanel: ItemRenderer = ({ svg, bboxPx }) => {
    const frameStroke = 0.45;
    const frameColor = "#a64022";

    const frame = {
        x: bboxPx.x + frameStroke / 2,
        y: bboxPx.y + frameStroke / 2,
        w: Math.max(0, bboxPx.w - frameStroke),
        h: Math.max(0, bboxPx.h - frameStroke),
    };

    svg.rect(frame.w, frame.h).move(frame.x, frame.y).fill("none").stroke({ width: frameStroke, color: frameColor });

    const holeD = Math.max(0.8, Math.min(1.6, Math.min(bboxPx.w, bboxPx.h) * 0.006));
    const radius = holeD / 2;
    const dotColor = frameColor;

    const safeX0 = bboxPx.x + frameStroke + radius;
    const safeY0 = bboxPx.y + frameStroke + radius;
    const safeW = Math.max(0, bboxPx.w - 2 * frameStroke - 2 * radius);
    const safeH = Math.max(0, bboxPx.h - 2 * frameStroke - 2 * radius);
    if (safeW <= 0 || safeH <= 0) return;

    const pitchTargetX = 2;
    const pitchTargetY = 2;

    let cols = Math.max(2, Math.floor(safeW / pitchTargetX) + 1);
    let rows = Math.max(2, Math.floor(safeH / pitchTargetY) + 1);

    const MAX_DOTS = 5000;
    if (rows * cols > MAX_DOTS) {
        const k = Math.sqrt((rows * cols) / MAX_DOTS);
        cols = Math.max(2, Math.floor(cols / k));
        rows = Math.max(2, Math.floor(rows / k));
    }

    const stepX = cols > 1 ? safeW / (cols - 1) : safeW;
    const stepY = rows > 1 ? safeH / (rows - 1) : safeH;

    for (let r = 0; r < rows; r++) {
        const y = safeY0 + r * stepY;
        for (let c = 0; c < cols; c++) {
            const x = safeX0 + c * stepX;
            svg.circle(holeD).center(x, y).fill(dotColor);
        }
    }
};
